module.exports = __webpack_public_path__ + "static/media/Icon-send.3391548b.svg";